exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-sm {\n    max-width: 500px !important;\n}\n", ""]);

// exports
